export function createNotification({ hasSubscriptions, slug, brandName }) {
  return {
    date: new Date().toUTCString(),
    action: hasSubscriptions ? 'subscribedToBrand' : 'subscribedToFirstBrand',
    slug: hasSubscriptions ? `/${slug}` : '/wijzijnvoor-jijook',
    isRead: false,
    brand: {
      slug: slug === 'portal' ? '' : slug,
      name: brandName,
    },
  };
}
